<!-- eslint-disable vue/multi-word-component-names -->
<!-- Copyright (c) 2024 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="company-main">
    <Menus :menu="menus" @menuClicked="handleMenuClick" />
    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title="title"
      @save="saveCountry"
      :requiredError="entryError"
      :errorMessages="errorMessage"
      :viewMode="viewMode"
      @requiredClicked="errorMessageClicked"
      :successMessages="successMessages"
      :updatedBy="updatedBy"
      :createdBy="createdBy"
    >
      <Input
        placeholder="Country Code"
        :isDisabled="disableCountryCode"
        :inputValue.sync="countryCode"
        :isRequired="true"
        validator="alphabetic,2,uppercase"
        ref="countryCode"
        :errorMessage.sync="countryCodeError"
      />

      <Input
        placeholder="Country Name"
        :isDisabled="disable"
        :inputValue.sync="country"
        :isRequired="true"
        ref="country"
        :errorMessage.sync="countryNameError"
        validator="text,30,uppercase,alphanumeric,all"
      />

      <InputQuery
        placeholder="Continent Code"
        :isDisabled="disable"
        :items="continentList"
        itemKey="Continent Code - Continent Name"
        descKey="Continent Name"
        :isRequired="true"
        :selectedObject.sync="selectedCountryContinent"
        :search.sync="continentInput"
        ref="countryContinent"
        :errorMessage.sync="continentError"
      />

      <Input
        placeholder="ISO3"
        :isDisabled="disable"
        :inputValue.sync="ISO3"
        :isRequired="true"
        validator="alphabetic,3,uppercase"
        ref="countryISO3"
        :errorMessage.sync="countryISO3Error"
      />
    </PopupEntry>

    <div class="right-container">
      <TableBox title="Country" :tableData="countryList" :selectedRow.sync="selectedCountry" />
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      menus: [
        {
          title: 'New Country',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: true,
        },
        {
          title: 'Edit Country',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: true,
        },
        {
          title: 'Delete Country',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: true,
        },
        {
          title: 'View Country',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: 'MnuQuery',
          visible: true,
          enabled: true,
        },
      ],
      // data from API GET
      countryCode: '',
      country: '',
      userID: '',
      continentCode: '',
      ISO3: '',
      createdBy: '',
      updatedBy: '',
      // Pop up box setting
      popupEntryShow: false,
      title: '',
      disable: false,
      disableCountryCode: false,
      entryError: [],
      errorMessage: [],
      successMessages: [],
      viewMode: false,
      saveOption: '',
      continentInput: '',
      // Query Selector Data
      selectedCountryContinent: null,
      // Row selected from table
      selectedCountry: [],
      // Data fectched from API to display in the table
      countryList: [],
      continentList: [],
      // Error Messages
      countryNameError: '',
      continentError: '',
      countryISO3Error: '',
      countryCodeError: '',
    };
  },
  methods: {
    errorMessageClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },
    clearErrorMessages: function () {
      this.countryNameError = '';
      this.continentError = '';
      this.countryISO3Error = '';
      this.countryCodeError = '';
    },
    getSpecificCountry: async function (record) {
      this.$fullscreenLoading('Getting Details');
      const details = (
        await this.$apiCallV2(`/Master/GetDetailsMaster`, {
          masterfile: 'COUNTRY',
          recordid: record,
        })
      )['Country'];
      this.countryCode = details['CountryCode'];
      this.country = details['Country'];
      this.continentCode = details['ContinentCode'];
      this.ISO3 = details['ISO3'];
      this.createdBy = `${details['UserCreated'] || ''} ${
        details['TimeCreated'] ? new Date(details['TimeCreated']).formatString('dd/MM/yyyy HH:mm') : ''
      }`;
      this.updatedBy = `${details['UserID'] || ''} ${
        details['DateUpdated'] ? new Date(details['DateUpdated']).formatString('dd/MM/yyyy HH:mm') : ''
      }`;
      this.$fullscreenLoading();
    },
    getContinentList: async function () {
      this.$fullscreenLoading('Getting Details');
      const continentListAPI = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'CONTINENT',
      });
      this.continentList = continentListAPI.map((continent) => ({
        ...continent,
        'Continent Code - Continent Name': `${continent['Continent Code']} - ${continent['Continent Name']}`,
      }));
      this.$fullscreenLoading();
    },
    getAllCountryDetails: async function () {
      this.$fullscreenLoading('Getting Details');
      this.countryList = [];
      this.countryList = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'COUNTRY',
      });
      this.$fullscreenLoading();
    },
    // Get the object for query selector
    setQuerySelector: function () {
      this.selectedCountryContinent = this.continentList.getSelected(this.continentCode, 'Continent Code');
    },
    clearInputFields: function () {
      this.countryCode = '';
      this.country = '';
      this.dateUpdated = '';
      this.userID = '';
      this.continentCode = '';
      this.ISO3 = '';
      this.userCreated = '';
      this.timeCreated = '';
      this.selectedCountryContinent = null;
      this.continentInput = '';
    },
    handleMenuClick: async function (menu) {
      this.errorMessage = [];
      this.entryError = [];
      this.successMessages = [];
      this.clearErrorMessages();

      switch (menu.title) {
        case 'View Country':
          if (this.selectedCountry.length == 0) {
            this.$showAlert('error', 'No Country Selected', 'Please select a record to view');
          } else {
            await this.getSpecificCountry(this.selectedCountry[0]['Country Code']);
            this.setQuerySelector();
            this.disable = true;
            this.disableCountryCode = true;
            this.viewMode = true;
            this.title = 'View Country';
            this.popupEntryShow = true;
          }
          break;
        case 'Edit Country':
          if (this.selectedCountry.length == 0) {
            this.$showAlert('error', 'No Country Selected', 'Please select a record to edit');
          } else {
            await this.getSpecificCountry(this.selectedCountry[0]['Country Code']);

            this.saveOption = 'E';
            this.setQuerySelector();
            this.disable = false;
            this.disableCountryCode = true;
            this.viewMode = false;
            this.title = 'Edit Country';
            this.popupEntryShow = true;
          }
          break;
        case 'New Country':
          this.clearInputFields();
          this.createdBy = '';
          this.updatedBy = '';
          this.saveOption = 'N';
          this.disable = false;
          this.disableCountryCode = false;
          this.viewMode = false;
          this.title = 'New Country';
          this.popupEntryShow = true;
          break;
        case 'Delete Country': {
          if (this.selectedCountry.length == 0) {
            this.$showAlert('error', 'No Country Selected', 'Please select a record to delete');
            return;
          }
          const deleting = await this.$showAlert(
            'warning',
            'Delete Country',
            `Are you sure you want to delete Country Code ${this.selectedCountry[0]['Country Code']} ?`,
            [
              { text: 'Delete', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ],
          );

          if (deleting == 'Cancel') {
            return;
          }

          this.$fullscreenLoading('Deleting Country');
          const result = await this.$apiCallV2('/Country/SaveCountry', {
            action: 'D',
            countrycode: this.selectedCountry[0]['Country Code'],
          });
          this.$fullscreenLoading();
          if (result[0]['Results'] == 0) {
            this.$showAlert(
              'success',
              'Country Code Deleted',
              `Successfully deleted Country Code ${this.selectedCountry[0]['Country Code']}`,
            );
            this.$nextTick(async () => await this.getAllCountryDetails());
            this.selectedCountry = [];
            return;
          }
          this.$showAlert(
            'error',
            'Country NOT Deleted',
            `There was an error deleting Country Code : ${this.selectedCountry[0]['Country Code']}`,
          );

          break;
        }
      }
    },
    saveCountry: async function () {
      this.entryError = [];
      this.errorMessage = [];
      const isValid = this.checkFields();
      if (isValid) {
        this.continentCode = this.selectedCountryContinent['Continent Code'];

        const dataToPost = {
          countrycode: this.countryCode,
          country: this.country,
          continentcode: this.continentCode,
          action: this.saveOption,
          iso3: this.ISO3,
        };

        this.$fullscreenLoading('Saving Country');
        const postUpdate = await this.$apiCallV2('/Country/SaveCountry', dataToPost);
        this.$fullscreenLoading();

        if (postUpdate[0].Results >= 1) {
          this.errorMessage.push(postUpdate[0].ErrMsg);
        } else {
          if (this.saveOption == 'N') {
            this.successMessages.push('Successfully created Country Code : ' + this.countryCode);
          }
          if (this.saveOption == 'E') {
            this.successMessages.push('Successfully edited Country Code : ' + this.countryCode);
          }
          this.viewMode = true;
          this.disable = true;
          this.disableCountryCode = true;
          this.title = 'View Country';
          this.getAllCountryDetails();
        }
      }
    },
    checkFields: function () {
      if (!this.country || this.country.trim().length == 0) {
        this.countryNameError = 'Country Name is Required !';
        this.entryError.push({
          key: 'country',
          value: this.countryNameError,
        });
      }

      if (!this.countryCode) {
        this.countryCodeError = 'Country Code is Required !';
        this.entryError.push({
          key: 'countryCode',
          value: this.countryCodeError,
        });
      }

      if (this.countryCode && this.countryCode.trim().length != 2) {
        this.countryCodeError = 'Country Code must be 2 letters';
        this.entryError.push({
          key: 'countryCode',
          value: this.countryCodeError,
        });
      }

      if (!this.continentInput) {
        this.continentError = 'Continent Code is Required !';
        this.entryError.push({
          key: 'countryContinent',
          value: this.continentError,
        });
      }

      if (this.continentInput && this.selectedCountryContinent === null) {
        this.continentError = 'Invalid Continent Code !';
        this.entryError.push({
          key: 'countryContinent',
          value: this.continentError,
        });
      }

      if (!this.ISO3) {
        this.countryISO3Error = 'ISO3 is Required !';
        this.entryError.push({
          key: 'countryISO3',
          value: this.countryISO3Error,
        });
      }

      if (this.ISO3 && this.ISO3.length !== 3) {
        this.countryISO3Error = 'ISO3 value must be 3 letters';
        this.entryError.push({
          key: 'countryISO3',
          value: this.countryISO3Error,
        });
      }
      return this.entryError.length == 0; // return true if entry error length is zero
    },
  },
  mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Country') {
        x.data.forEach((k) => {
          //key in menu same as control value from api
          const selectedMenu = this.menus.find((m) => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
          }
        });
      }
    });
    this.getContinentList();
    this.getAllCountryDetails();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.company-main {
  padding: 10px 45px;
  font-size: 12px;
  display: flex;

  > .right-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }
}
</style>
